<div class="channel-control__wrapper">
  <input
    type="text"
    class="lum-input"
    [(ngModel)]="selectedItem"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    (focus)="loadCompanies({})"
    (input)="onSearch($event)"
    lumDebounceTime
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <ng-container *ngIf="!(loading$ | async); else loadingTemplate">
      <mat-option
        *ngFor="let option of companies$ | async; trackBy: trackById"
        [value]="option"
        (onSelectionChange)="onSelectItem(option)"
      >
        {{ option?.business_name }}
      </mat-option>
    </ng-container>
    <ng-template #loadingTemplate>
      <mat-option>
        <div class="flex gap-4">
          <mat-progress-spinner
            class="progress-spinner mt-3"
            diameter="24"
            mode="indeterminate"
          ></mat-progress-spinner>
          <small>Loading...</small>
        </div>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
